// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    parentId: z.string().max(21).nullable().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    parentId: z.string().max(21).nullable(),
});
export const OrganizationDepartments = Object.freeze({
    table: 'organization_departments',
    tableSingular: 'organization_department',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        id: 'id',
        name: 'name',
        parentId: 'parent_id',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'id',
        'name',
        'parentId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
